import { FC } from "react";
import { subHeaderStyle } from "./SubHeader.styles";

export const SubHeader: FC<{ text: string }> = ({ text }) => {
    return <h2 css={subHeaderStyle}>{text}</h2>;
};
